<template>
  <div class="phd-item">
    <div class="row">
      <div class="col-sm-6 col-xs-12">
        <b>
          <a @click="$emit('edit', phd)" class="phd-item__fio">
            {{ phd.fio }}
          </a>
        </b>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-xs-12 overflow-block">
        <span :title="phd.org_name">
          <span style="color: #888">Организация:</span> {{ phd.org_name }}
        </span>
      </div>
      <div class="col-sm-6 col-xs-12">
        <span style="color: #888">ИНН:</span> {{ phd.inn }}
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-xs-12">
        <span style="color: #888">Дата начала:</span> {{ formatDate(phd.begin_date) }}
      </div>
      <div class="col-sm-6 col-xs-12">
        <span style="color: #888">Дата окончания:</span> {{ formatDate(phd.expire_date) }}
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xs-12 mt-10">
        <button class="btn btn-sm btn-primary" @click="$emit('duplicate', phd)">Дублировать</button>
        <button class="btn btn-sm btn-primary" @click="$emit('edit', phd)">Редактировать</button>
        <button class="btn btn-sm btn-danger" @click="$emit('delete', phd)">Удалить</button>
      </div>
    </div>
  </div>
</template>

<script>
import '@/common/assets/styles/phd-item.scss'
import moment from 'moment/moment'

export default {
  name: 'PhdItem',

  props: {
    phd: { type: Object, required: true }
  },

  methods: {
    formatDate(date) {
      return date ? moment(date).format('DD.MM.YYYY') : ''
    }
  }
}
</script>
